export default {
    apiUrl: "https://b2b-api.finekra.com/api",
}